export enum IntegrationType {
  AWS = 'aws',
  AZURE = 'azure',
  Appdynamics = 'appdynamics',
  Blazemeter = 'blazemeter',
  Custom = 'custom',
  Datadog = 'datadog',
  DatadogEU = 'datadog_eu',
  DatadogUS1Fed = 'datadog_us1_fed',
  DatadogUS3 = 'datadog_us3',
  DatadogUS5 = 'datadog_us5',
  Dynatrace = 'dynatrace',
  GCP = 'gcp',
  Grafana = 'grafana',
  K6 = 'k6',
  LoadGeneratorCustom = 'load_generator_custom',
  Newrelic = 'newrelic',
  Pagerduty = 'pagerduty',
  Prometheus = 'prometheus'
}

export enum ExternalIntegrationType {
  LoadGenerator = 'LOAD_GENERATOR',
  StatusCheck = 'STATUS_CHECK'
}
